import React from 'react';

import classnames from 'classnames/bind';
import styles from './OrderHistory.module.scss';
import { Typography, Skeleton } from 'gd-design-library';

const CN = 'order-history';
const summaryClassName = `${CN}__summary`;
const detailsClassName = `${CN}__details`;
const marginedClassName = `${detailsClassName}__margined`;

const cx = classnames.bind(styles);

export const OrderHistorySkeleton: React.FC = () => (
  <div
    className={ cx(CN) }
  >
    <div
      className={ cx(summaryClassName, marginedClassName) }
    >
      <Typography variant='h6'>Order History</Typography>
    </div>
    <div className={ cx(detailsClassName) }>
      <Skeleton className={ cx(marginedClassName) } variant='rectangular' height='90px' />
      <Skeleton className={ cx(marginedClassName) } variant='rectangular' height='90px' />
      <Skeleton className={ cx(marginedClassName) } variant='rectangular' height='90px' />
      <Skeleton className={ cx(marginedClassName) } variant='rectangular' height='90px' />
      <Skeleton className={ cx(marginedClassName) } variant='rectangular' height='90px' />
    </div>
  </div>
);
